import React, { useState, useReducer, useEffect } from "react";
import { useDispatch } from "react-redux";

// Components
import Spinner from "../Components/Spinner";
import ToastError from "../Components/ToastError";
import InputField from "../Components/Forms/InputField";
import SelectField from "../Components/Forms/SelectField";
import SearchInputField from "../Components/Forms/SearchInputField";
import ModalSearchEquipment from "./ModalSearchEquipment";
import ModalSearchChip from "./ModalSearchChip";
import ImportModal from "../Components/Modals/Import-modal";

// Services
import { equipmentService } from "../../Services/equipment.service";
import { chipService } from "../../Services/chip.service";
import { toDateTimeISOString } from "../../Services/string.service";
import { importService } from "../../Services/import.service";
import { fileService } from "../../Services/file.service";

// Icons
import { AiOutlineSearch, AiFillSave } from "react-icons/ai";
import { FcSmartphoneTablet } from "react-icons/fc";
import { CgImport } from "react-icons/cg";

// Constants
const _pageTitle = "Cadastro de Equipamentos";
const _registerTitle = "Cadastrando novo Equipamento";
const _editTitle = "Editando Equipamento";

const formInitialValues = {
	id: 0,
	serial: 0,
	modelEquipmentId: "",
	lineNumber: "",
	iccid: "",
	mobileOperatorId: 0,
	accreditedId: 0,
	address: "",
	statusEquipmentId: 0,
	privateAPNSince: "",
	ChipId: 0,
};

const formReducer = (state, event) => {
	if (event.setter) {
		return event.equipment;
	}
	if (event.reset) {
		return formInitialValues;
	}

	return {
		...state,
		[event.name]: event.value,
	};
};

const filterReducer = (state, event) => {
	if (event.reset) {
		return { lineNumber: "", iccid: "" };
	}
	return {
		...state,
		[event.name]: event.value,
	};
};

const filterChipReducer = (state, event) => {
	if (event.reset) {
		return { lineNumber: "", iccid: "" };
	}
	return {
		...state,
		[event.name]: event.value,
	};
};

const alertReducer = (state, event) => {
	if (event.reset) {
		return { show: false, message: "", color: "danger" };
	}
	return {
		...state,
		show: event.show,
		message: event.message,
		color: event.color,
	};
};

const Equipments = () => {
	const [formData, setFormData] = useReducer(formReducer, {});
	const [isLoading, setIsLoading] = useState(false);
	const [showToast, setShowToast] = useState(false);
	const [actionTitle, setActionTitle] = useState("Dado do Equipamento");
	const [alert, setAlert] = useReducer(alertReducer, {
		show: false,
		message: "",
		color: "danger",
	});
	const [showSearchModal, setShowSearchModal] = useState(false);
	const [showChipModal, setShowChipModal] = useState(false);
	const [showFields, setShowFields] = useState(false);
	const [setShowDelete] = useState(false);
	const [filter, setFilter] = useReducer(filterReducer, {}); // eslint-disable-next-line
	const [chipFilter, setChipFilter] = useReducer(filterChipReducer, {});
	const [setSelectedEquipment] = useState({});
	const [selectedChip, setSelectedChip] = useState({}); // eslint-disable-next-line
	const [listModels, setListModels] = useState([]);
	const [listAccredited, setListAccredited] = useState([]);
	const [listStatus, setListStatus] = useState([]);
	const [listOperators, setListOperators] = useState([]);
	const [showImportModal, setShowImportModal] = useState(false);

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch({ type: "title", value: _pageTitle });
	}, [dispatch]);

	const onSearch = () => {
		setAlert({
			reset: true,
		});

		if (filter.lineNumber || filter.serial) {
			setShowSearchModal(true);
		}
	};

	const onSearchChip = () => {
		setAlert({
			reset: true,
		});

		if (chipFilter.lineNumber) {
			setShowChipModal(true);
		}
	};

	const onNew = () => {
		setShowDelete(false);
		setAlert({
			reset: true,
		});
		setFormData({
			reset: true,
		});
		setShowFields(true);
		setActionTitle(_registerTitle);
	};

	const onCancel = () => {
		setAlert({
			reset: true,
		});
		setFormData({
			reset: true,
		});
		setShowFields(false);
		setShowDelete(false);
		setSelectedChip({});
		setChipFilter({
			reset: true,
		});
	};

	const onCloseToast = () => {
		setShowToast(false);
	};

	const handleFilterChange = (event) => {
		setFilter({
			name: event.target.name,
			value: event.target.value.trim(),
		});
	};

	const handleFilterChipChange = (event) => {
		setChipFilter({
			name: event.target.name,
			value: event.target.value.trim(),
		});
	};

	const handleFormChange = async (event) => {
		setFormData({
			name: event.target.name,
			value: event.target.value,
		});
	};

	const handleSelectEquipment = async (equipment) => {
		setSelectedEquipment(equipment);

		setFormData({
			setter: true,
			equipment: equipment,
		});

		if (equipment.lineNumber) {
			var chip = await chipService.searchByLineNumber(equipment.lineNumber);
			if (chip && chip.length > 0) {
				setSelectedChip(chip[0]);
				setChipFilter({
					name: "lineNumber",
					value: chip[0].numberLine,
				});
			}
		}

		setShowFields(true);
		setShowSearchModal(false);
		setActionTitle(_editTitle);
		setShowDelete(true);
	};

	const handleSelectChip = async (chip) => {
		setSelectedChip(chip);
		setChipFilter({
			name: "lineNumber",
			value: chip.numberLine,
		});
		setShowChipModal(false);
	};

	const onSave = async () => {
		if (selectedChip?.id == null) {
			setAlert({
				show: true,
				message: "Pesquise e selecione uma linha!",
				color: "danger",
			});
			return;
		}
		if (!formData.serial) {
			setAlert({
				show: true,
				message: "Forneça um serial!",
				color: "danger",
			});
			return;
		}
		if (!formData.modelEquipmentId) {
			setAlert({
				show: true,
				message: "Forneça um modelo!",
				color: "danger",
			});
			return;
		}
		if (!formData.statusEquipmentId) {
			setAlert({
				show: true,
				message: "Forneça o Status!",
				color: "danger",
			});
			return;
		}

		// Define demais campos
		formData.startDate = new Date().toISOString()
		formData.chipId = selectedChip?.id;

		try {
			delete formData["iccId"];
			delete formData["modelEquipmentName"];
			delete formData["statusEquipmentName"];
			delete formData["line"];
		} catch (error) {}

		console.log(formData);

		try {
			setIsLoading(true);

			var created = await equipmentService.save(formData);
			setFormData({
				name: "id",
				value: created,
			});
			if (created) {
				setAlert({
					show: true,
					message: "Equipamento salvo com sucesso!",
					color: "success",
				});
			}
		} catch (error) {
			console.log(error);
			setAlert({
				show: true,
				message: "Não foi possível salvar. tente novamente mais tarde. ",
			});
		} finally {
			setIsLoading(false);
		}
	};

	const handleCloseImport = () => {
		setShowImportModal(false);
	};

	const onImport = () => {
		setShowImportModal(true);
	};

	const handleImport = async (file) => {
		let base64File = await fileService.toBase64(file);
		base64File = base64File.split("base64,")[1];

		var payload = {
			scheduleTypeId: "Equipamentos",
			fileName: file.name,
			fileType: file.type,
			contentType: file.type,
			contentFile: base64File,
			usePeriod: false,
			dateTimeStart: toDateTimeISOString(new Date()),
			dateTimeEnd: toDateTimeISOString(new Date()),
			created: toDateTimeISOString(new Date()),
		};

		await importService.upload(payload);

		setShowImportModal(false);

		setAlert({
			show: true,
			message: "Importação do arquivo realizada!",
			color: "success",
		});
	};

	useEffect(() => {
		(async () => {
			var response_models = await equipmentService.listModels();
			if (response_models) {
				const withKeys = response_models.map((item) => {
					return {
						...item,
						key: crypto.randomUUID(),
					};
				});
				setListModels(withKeys);
			}

			var response_acrredited = await equipmentService.listAccredited();
			if (response_acrredited) {
				const withKeys = response_acrredited.map((item) => {
					return {
						...item,
						key: crypto.randomUUID(),
					};
				});
				setListAccredited(withKeys);
			}

			var response_status = await equipmentService.listStatus();
			if (response_status) {
				const withKeys = response_status.map((item) => {
					return {
						...item,
						key: crypto.randomUUID(),
					};
				});
				setListStatus(withKeys);
			}

			var response_operators = await chipService.listMobileOperator();
			if (response_operators) {
				const withKeys = response_operators.map((item) => {
					return {
						...item,
						key: crypto.randomUUID(),
					};
				});
				setListOperators(withKeys);
			}
		})();
	}, []);

	return (
		<>
			<div className="container-xxl flex-grow-1 container-p-y">
				{isLoading ? <Spinner /> : ""}

				<ToastError show={showToast} closeToast={onCloseToast} />

				<ModalSearchEquipment
					show={showSearchModal}
					handleClose={setShowSearchModal}
					filter={filter}
					handleSelect={handleSelectEquipment}
				/>

				<ModalSearchChip
					show={showChipModal}
					handleClose={setShowChipModal}
					filter={chipFilter}
					handleSelect={handleSelectChip}
				/>

				<ImportModal
					title={"Equipamentos"}
					callBackImport={handleImport}
					show={showImportModal}
					handleClose={handleCloseImport}
				/>

				{/* <DeleteModal
          itemName={isDeleting.itemName}
          itemRemoveId={isDeleting.itemRemoveId}
          callBackRemove={handleRemove}
          show={isDeleting.show}
          handleClose={handleCloseModal}
        /> */}

				<div className="row">
					<h5>Preencha os campos para buscar ou crie um novo</h5>
					<div className="row">
						<div className="mb-3 col-md-3">
							<div className="mb-3">
								<SearchInputField
									name="serial"
									label="Serial"
									type="text"
									tabIndex="1"
									onChange={handleFilterChange}
								/>
							</div>
						</div>
						<div className="mb-3 col-md-3">
							<div className="mb-3">
								<SearchInputField
									name="lineNumber"
									label="Número Linha"
									type="text"
									tabIndex="2"
									onChange={handleFilterChange}
								/>
							</div>
						</div>

						<div className="mb-3 col-md-4 col-lg-4">
							<div className="d-flex justify-content-around">
								<div>
									<button
										type="button"
										className="btn btn-primary"
										tabIndex={3}
										disabled={showFields}
										onClick={onSearch}
									>
										<AiOutlineSearch className="icon-in-button" />
										Buscar
									</button>
								</div>
								<div>
									<button
										type="button"
										className="btn btn-primary"
										disabled={showFields}
										onClick={onNew}
										tabIndex={4}
									>
										<FcSmartphoneTablet className="icon-in-button" />
										&nbsp; Novo
									</button>
								</div>
								<div>
									<button
										type="button"
										className="btn btn-primary"
										onClick={onImport}
										tabIndex={5}
									>
										<CgImport className="icon-in-button" />
										&nbsp; Importar
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>

				{alert?.show ? (
					<div
						className={`alert alert-${alert.color} alert-dismissible`}
						role="alert"
					>
						{alert?.message}
						<button
							type="button"
							className="btn-close"
							data-bs-dismiss="alert"
							onClick={() => setAlert({ show: false, message: "" })}
							aria-label="Close"
						></button>
					</div>
				) : (
					""
				)}

				<div
					className="row"
					style={showFields ? { display: "" } : { display: "none" }}
				>
					<h4 className="fw-bold py-3 mb-4">
						<span className="text-muted fw-light">{actionTitle} </span>
					</h4>

					<div className="col-4">
						<div className="row mb-3">
							<InputField
								label="Serial"
								name="serial"
								type="text"
								tabIndex="5"
								grid_length="6"
								value={formData.serial || ""}
								onChange={handleFormChange}
							/>
						</div>

						<div className="row mb-3">
							<SelectField
								name="modelEquipmentId"
								label="Modelo"
								tabIndex="6"
								grid_length="6"
								itens={listModels}
								value={formData.modelEquipmentId || ""}
								onChange={handleFormChange}
							/>
						</div>

						<div className="row mb-3">
							<SelectField
								name="accreditedId"
								label="Credenciado"
								tabIndex="7"
								grid_length="7"
								itens={listAccredited}
								value={formData.accreditedId || ""}
								onChange={handleFormChange}
							/>
						</div>

						<div className="row mb-3">
							<InputField
								name="address"
								label="Endereço"
								type="text"
								tabIndex="8"
								grid_length="8"
								value={formData.address || ""}
								onChange={handleFormChange}
							/>
						</div>

						<div className="row mb-3">
							<SelectField
								name="statusEquipmentId"
								label="Status"
								tabIndex="9"
								grid_length="6"
								itens={listStatus}
								value={formData.statusEquipmentId || ""}
								onChange={handleFormChange}
							/>
						</div>
					</div>
					<div className="col-4">
						<div className="row mb-3">
							<InputField
								label="Número da linha"
								name="lineNumber"
								type="number"
								tabIndex="10"
								grid_length="6"
								value={chipFilter?.lineNumber || ""}
								onChange={handleFilterChipChange}
							/>
						</div>

						<div className="row mb-3">
							<SelectField
								name="mobileOperatorId"
								label="Operadora"
								tabIndex="7"
								grid_length="8"
								readOnly={true}
								value={selectedChip?.mobileOperatorId || ""}
								itens={listOperators}
							/>
						</div>

						<div className="row mb-3">
							<InputField
								label="ICCID"
								name="iccid"
								type="number"
								tabIndex="6"
								grid_length="6"
								readOnly={true}
								value={selectedChip?.iccid || ""}
							/>
						</div>
					</div>

					<div className="col-4">
						<button
							type="button"
							className="btn btn-primary"
							tabIndex={3}
							onClick={onSearchChip}
						>
							<AiOutlineSearch className="icon-in-button" />
							Buscar
						</button>
					</div>

					<div className="mt-4">
						<button
							type="button"
							tabIndex={9}
							className="btn btn-primary me-2"
							onClick={async () => onSave()}
						>
							<AiFillSave className="icon-in-button" />
							&nbsp; Salvar
						</button>

						<button
							type="reset"
							className="btn btn-outline-secondary  me-2"
							onClick={onCancel}
							tabIndex={10}
						>
							Cancelar
						</button>

						{/* <button
              type='button'
              className='btn btn-danger'
              tabIndex={11}
              style={showDelete ? { display: "" } : { display: "none" }}>
              Remover
            </button> */}
					</div>
				</div>
			</div>
		</>
	);
};
export default Equipments;
